import * as React from 'react';
import { FormControl } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { ResultatAngivesIEnum } from '../../models/enums/ResultatAngivesIEnum';

export interface ForsoegIndtastningsfeltProps {
    holdId: string;
    antalBedoemmelsesFaktorer: number;
    onForsoegAdded: (holdId: string, value: string) => Promise<boolean>;
    onIndtastetValueChanged: (value: string, index: number) => void;
    onSamletResultatValueChanged: (value: string) => void;
    onSamletResultatSubmittet: (holdId: string) => void;
    resultatAngivesI?: ResultatAngivesIEnum;
    samletResultat: string;
    indtastedeValues: string[];
}

export default class ForsoegIndtastningsfelt extends React.Component<ForsoegIndtastningsfeltProps, any> {
    constructor(props: ForsoegIndtastningsfeltProps) {
        super(props);
    }

    onKeyPress(e: any, holdId: string) {
        if (e.key === 'Enter') {
            this.props.onSamletResultatSubmittet(holdId);
        }
    }

    focusNext(e: any, index: number) {
        if (e.key === 'Enter') {
            var nextInput = document.getElementById('input' + this.props.holdId + (index + 1));
            if (nextInput !== null) {
                nextInput.focus();
            } else {
                var samletInput = document.getElementById('inputSamlet' + this.props.holdId);
                if (samletInput !== null) {
                    samletInput.focus();
                }
            }
        }
    }    

    renderInput() {
        if (this.props.antalBedoemmelsesFaktorer > 0) {
            const inputFieldArray = new Array();
            for (let index = 0; index < this.props.antalBedoemmelsesFaktorer; index++) {
                inputFieldArray.push(
                    <FormControl
                        id={'input' + this.props.holdId + index}
                        key={index}
                        type='text'
                        name='point'
                        value={this.props.indtastedeValues[index]}
                        disabled={false}
                        onChange={e => this.props.onIndtastetValueChanged(e.target.value, index)}
                        onKeyPress={e => this.focusNext(e, index)}
                    />
                );
            }
            return (
                inputFieldArray
            );
        }
        return <div />;
    }

    getResultatAngivesITekst(): string {
        let tekst = '';
        switch (this.props.resultatAngivesI) {
            case ResultatAngivesIEnum.Heltal:
               tekst = 'Resultat skal angives i heltal'; 
               break;
            case ResultatAngivesIEnum.Kommatal:
                tekst = 'Resultat skal angives i kommatal'; 
                break;
            default:
                tekst = '';
                break;
        }

        return tekst;
    }

    render() {
        return (
            <div>
                <div>
                    {this.renderInput()}
                </div>
                <FormControl
                    id={'inputSamlet' + this.props.holdId}
                    type='text'
                    name='point'
                    value={this.props.samletResultat}
                    disabled={false}
                    onChange={e => this.props.onSamletResultatValueChanged(e.target.value)}
                    onKeyPress={e => this.onKeyPress(e, this.props.holdId)}
                    tooltip={this.getResultatAngivesITekst()}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/opgaveBedoemmelse/ForsoegIndtastningsfelt.tsx